import { render, staticRenderFns } from "./EditTextModuleModal.vue?vue&type=template&id=5c50eb18&scoped=true&"
import script from "./EditTextModuleModal.vue?vue&type=script&lang=js&"
export * from "./EditTextModuleModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTextModuleModal.vue?vue&type=style&index=0&id=5c50eb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50eb18",
  null
  
)

export default component.exports